var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[(!_vm.$store.state.loading)?_c('PageError',{attrs:{"code":_vm.code || _vm.code === 0 ? _vm.code : _vm.error ? _vm.error.statusCode : 404}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }